define('view/controller/booking/reschedule/BookingRescheduleLayout',['require','marionette','view/controller/booking/timezone/CompanyTimeView','view/controller/booking/reschedule/BookingRescheduleDetailsView','collection/TimeZoneCollection','Config'],function (require) {
	
	var Parent = require('marionette').LayoutView;
    var CompanyTimeView = require('view/controller/booking/timezone/CompanyTimeView');
    var BookingRescheduleDetailsView = require('view/controller/booking/reschedule/BookingRescheduleDetailsView');
    var TimeZoneCollection = require('collection/TimeZoneCollection');
    var Config = require('Config');

	/**
	 * Booking result layout
	 * 
	 * @class BookingResultLayout
	 */
	return Parent.extend({
	
	    template: '#booking_reschedule_layout',
        
        regions: {
            'timeline': {
                selector: '.sb-timeline',
                allowMissingEl: true
            },
            'time': {
                selector: '#sb_booking_company_time',
                allowMissingEl: true
            },
            'details': {
                selector: '.sb-details',
                allowMissingEl: true
            },
        },
        
        modelEvents: {
            'sync': '_startStep',
        },
        
        initialize: function() {
            Parent.prototype.initialize.apply(this, arguments);
            
            var stepManager = this.getOption('stepManager');
            var stepParams = this.getOption('stepParams');
            
            _.extend(stepParams, {
    			stepManager: stepManager, 
				bookingModel: this.model
			});
            
            this.timelineStep = stepManager._getTimelineStepInstance(stepParams);
            
            this._timeZoneCollection = new TimeZoneCollection();
            this.listenTo(this.getOption('clientTimeZone'), 'sync', this._showDetailsView);
        },
        
        _startStep: function () {
            this.timelineStep.start();
            // console.log('started', this.model.toJSON());
            this.render();
        },
        
        onRender: function () {
            if (this.model.get('can_reschedule_booking')) {
                this.showChildView('timeline', this.timelineStep.getStepView());
            }
            
            this._showDetailsView();
            
            var companyTimeView = new CompanyTimeView({
                companyTimeZone: this.getOption('companyTimeZone'),
                clientTimeZone: this.getOption('clientTimeZone'),
                timeZoneCollection: this._timeZoneCollection
            });
            this.showChildView('time', companyTimeView);
        },
        
        _showDetailsView: function () {
            var detailsView = new BookingRescheduleDetailsView({
                model: this.model,
                companyTimeZone: this.getOption('companyTimeZone'),
                clientTimeZone: this.getOption('clientTimeZone')
            });
            this.showChildView('details', detailsView);
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'booking_reschedule'
            });
        },
        
        serializeData: function () {
            return _.extend(Parent.prototype.serializeData.apply(this), {
                'errors': this.model.validationError,
                'time_diff': this.getOption('clientTimeZone').get('time_diff')
            });
        }

	});
	
});
